import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { tap } from 'rxjs/operators';
import { Observable, finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpRespuesta } from '../models/http-respuesta.interface';
import { Usuario, UsuarioSesion } from '../models/usuario-sesion.interface';
import { EmpresaFacturas, FacturaDatos } from '../models/empresa-facturas.interface';
import { EmpresaProductosFacturados, ProductosFacturado } from '../models/empresa-productos-facturados.interface';
import { ProductoFacturado } from '../models/producto-trazabilidad.interface';
import { TrazabilidadProducto } from '../models/trazabilidad-producto.interface';
import { LoaderService } from '../shared/loader/services/loader.service';
@Injectable({ providedIn: 'root' })
export class EmpresaService {


    constructor(private http: HttpClient, private loaderService: LoaderService) { }

    create(usuario: Usuario): Observable<HttpRespuesta<Usuario>> {
        this.loaderService.activar();
        return this.http.post<HttpRespuesta<Usuario>>(environment.api.empresas, usuario).pipe(finalize(() => this.loaderService.desactivar()));
    }
    all(): Observable<HttpRespuesta<Usuario[]>> {
        this.loaderService.activar();
        return this.http.get<HttpRespuesta<Usuario[]>>(environment.api.empresas).pipe(finalize(() => this.loaderService.desactivar()));
    }
    facturas(): Observable<HttpRespuesta<FacturaDatos[]>> {
        this.loaderService.activar();
        return this.http.get<HttpRespuesta<FacturaDatos[]>>(environment.api.facturas).pipe(finalize(() => this.loaderService.desactivar()));
    }
    empresaFacturas(id: number): Observable<HttpRespuesta<EmpresaFacturas>> {
        this.loaderService.activar();
        return this.http.get<HttpRespuesta<EmpresaFacturas>>(environment.api.empresas + '/facturas/' + id).pipe(finalize(() => this.loaderService.desactivar()));
    }
    empresaProductos(id: number): Observable<HttpRespuesta<EmpresaProductosFacturados>> {
        this.loaderService.activar();
        return this.http.get<HttpRespuesta<EmpresaProductosFacturados>>(environment.api.empresas + '/productos/' + id).pipe(finalize(() => this.loaderService.desactivar()));
    }
    productoFacturado(id: number): Observable<HttpRespuesta<ProductoFacturado>> {
        this.loaderService.activar();
        return this.http.get<HttpRespuesta<ProductoFacturado>>(environment.api.productos_facturados + '/' + id).pipe(finalize(() => this.loaderService.desactivar()));
    }
    productosFacturados(): Observable<HttpRespuesta<ProductosFacturado[]>> {
        this.loaderService.activar();
        return this.http.get<HttpRespuesta<ProductosFacturado[]>>(environment.api.productos_facturados).pipe(finalize(() => this.loaderService.desactivar()));
    }
    trazabilidadProducto(traza_producto: TrazabilidadProducto): Observable<HttpRespuesta<TrazabilidadProducto>> {
        this.loaderService.activar();
        return this.http.post<HttpRespuesta<TrazabilidadProducto>>(environment.api.trazabilidad_productos, traza_producto).pipe(finalize(() => this.loaderService.desactivar()));
    }
    updateEmpresa(empresa: UsuarioSesion, id: number): Observable<HttpRespuesta<UsuarioSesion>> {
        this.loaderService.activar();
        return this.http.put<HttpRespuesta<UsuarioSesion>>(environment.api.empresas + '/' + id, empresa).pipe(finalize(() => this.loaderService.desactivar()))
    }
}
